module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/twoPhones_3x.39c8c61.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/twoPhones_3x.png
// module id = aQm2
// module chunks = 41